
import { Link } from 'react-router-dom';

export default function TestimonialsCTA() {
  return (
    <section className="py-20 px-6 bg-beige-100/50">
      <div className="max-w-4xl mx-auto text-center">
        <div className="w-20 h-20 flex items-center justify-center mx-auto mb-6 bg-amber-500 rounded-full">
          <i className="fas fa-paint-roller text-4xl text-white"></i>
        </div>

        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6">
          Ready to Start Your Project?
        </h2>
        
        <p className="text-base text-slate-600 mb-8 max-w-2xl mx-auto leading-relaxed">
          Join hundreds of satisfied customers who have transformed their homes with Brushour. Get your free quote today and experience the quality service that earns us five-star reviews.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/services"
            className="px-8 py-4 bg-amber-600 hover:bg-amber-700 text-white font-medium rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            Get a Free Quote
          </Link>
          <a
            href="tel:+447595037441"
            className="px-8 py-4 bg-sky-600 hover:bg-sky-700 text-white font-medium rounded-lg transition-colors duration-300 whitespace-nowrap cursor-pointer"
          >
            <i className="fas fa-phone mr-2"></i>
            Call Us Now
          </a>
        </div>
      </div>
    </section>
  );
}
